import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "personal-information" }

import store from "@/store";
import { computed } from "vue";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalInformationView',
  setup(__props) {

// 管理端个人信息页（只读展示当前登录的 manager 账号信息）
// 数据来源：登录后 /verify_token 写入 store 的 managerInfo（id/name/username/email）
const router = useRouter();
const manager = computed(() => store.getters["auth/managerInfo"]);

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, [
      _createElementVNode("i", {
        class: "iconfont icon-arrow_a back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }),
      _cache[1] || (_cache[1] = _createTextVNode(" 个人信息 ", -1))
    ]),
    (manager.value)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          shadow: "never"
        }, {
          header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "card-title" }, "账号信息", -1)
          ]))]),
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions, {
              column: 1,
              "label-width": "120px",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(manager.value.name || "—"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "用户名" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(manager.value.username || "—"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "邮箱" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(manager.value.email || "—"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "账号类型" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" 管理端账号（开发公司内部） ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_alert, {
              type: "info",
              closable: false,
              "show-icon": "",
              style: {"margin-top":"16px"},
              title: "如需修改密码，请在退出登录后通过登录页的「忘记密码」流程（邮箱验证）重置。"
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_el_card, {
          key: 1,
          shadow: "never"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_skeleton, { rows: 4 })
          ]),
          _: 1
        }))
  ]))
}
}

})